@if (data()) {
  <ul class="menu-items__sections" [ngClass]="data().gridTemplateClasses">
    @for (section of data().sections; track section; let j = $index) {
      <li class="menu-items__section">
        @for (item of section.items; track item; let i = $index) {
          <ul class="menu-items__groups">
            <li
              class="menu-items__group menu-items-group"
              [class.menu-items-group--active]="
                createCombiIndex(i, j) === activeIndex
              "
              @fadeInUp
            >
              <a
                class="menu-items-group__link"
                [routerLink]="['/' + localizePath(item?.page?.pretty_url)]"
                [externalLink]="item?.page?.external_url"
                routerLinkActive
                appCloseOverlayForActiveLink
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <h3 class="menu-items-group__title">
                  {{ item?.page?.title }}
                  @if (item?.children?.length) {
                    <fa-icon
                      class="menu-items-group__chevron"
                      stopPropagation
                      [icon]="faChevronDown"
                      size="sm"
                      (click)="onClick(i, j); $event.preventDefault()"
                      [class.rotate-180]="
                        createCombiIndex(i, j) === activeIndex
                      "
                    ></fa-icon>
                  }
                </h3>
              </a>
              @if (!isMobile || createCombiIndex(i, j) === activeIndex) {
                <ul class="menu-items-group__item menu-items-links">
                  @for (child of item?.children; track child) {
                    <li class="menu-items-links__item" @fadeInUpChild>
                      <a
                        [routerLink]="[
                          '/' + localizePath(child?.page?.pretty_url),
                        ]"
                        [externalLink]="child?.page?.external_url"
                        routerLinkActive
                        appCloseOverlayForActiveLink
                        [routerLinkActiveOptions]="{ exact: true }"
                        class="menu-items-links__link"
                        [title]="child?.page?.short_content || ''"
                        >{{ child?.page?.title || '?' }}</a
                      >
                    </li>
                  }
                </ul>
              }
            </li>
          </ul>
        }
      </li>
    }
  </ul>
} @else if (staticRequestState().loading) {
  <div class="loading-spinner-container">
    <span
      class="spinner-border spinner-border spinner-border-md"
      [class.loading-spinner-color]="!isEyeServiceEnabled()"
      role="status"
      aria-hidden="true"
    ></span>
  </div>
} @else if (staticRequestState().error) {
  <app-content-unavailable
    [style]="
      isEyeServiceEnabled()
        ? contentUnavailableStyleEnum.WHITE_BLACK
        : contentUnavailableStyleEnum.WHITE
    "
    (reload)="reload()"
  />
}
